import dayjs from 'dayjs';

import { FilterOption } from '../Filter/Filter';

const now = dayjs();

export const DateOptions: Array<FilterOption & { fromDate: string; toDate: string }> = [
  {
    id: 1,
    label: 'This',
    fromDate: now.startOf('month').format('YYYY-MM-DD'),
    toDate: now.endOf('month').format('YYYY-MM-DD'),
  },
  {
    id: 2,
    label: '3M',
    fromDate: now.subtract(2, 'month').startOf('month').format('YYYY-MM-DD'),
    toDate: now.endOf('month').format('YYYY-MM-DD'),
  },
  {
    id: 3,
    label: '6M',
    fromDate: now.subtract(5, 'month').startOf('month').format('YYYY-MM-DD'),
    toDate: now.endOf('month').format('YYYY-MM-DD'),
  },
  {
    id: 4,
    label: '12M',
    fromDate: now.subtract(11, 'month').startOf('month').format('YYYY-MM-DD'),
    toDate: now.endOf('month').format('YYYY-MM-DD'),
  },
];
